export default "__VITE_ASSET__CCy4CUbu__"